











import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import { ICProdProvider } from "@/models/providers/contractProduct";
import Context from "@/mixins/context";
import {
  ClientRoutes,
  AdminRoutes,
  UpmindClientRoutes
} from "@/data/enums/router";

@Component
export default class ContractProductUnpaidInvoicesMessage extends Mixins(
  Context
) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Prop({ default: true })
  public showOnCertainRoutes!: boolean;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get type() {
    if (this.cProdData.isSuspended) return "is-danger";
    if (this.cProdData.unpaidOverdueInvoices.length) return "is-danger";
    return "is-warning";
  }

  public get isVisbile() {
    if (this.cProdData.unpaidOverdueInvoices.length) return true;
    if (this.cProdData.unpaidInvoices.length)
      return this.showOnCertainRoutes
        ? ([
            ClientRoutes.CONTRACT_PRODUCT_OVERVIEW,
            AdminRoutes.CONTRACT_PRODUCT_OVERVIEW
          ] as string[]).includes(this.$route.name as string)
        : true;
    return false;
  }

  public get actionIsVisbile() {
    return !([
      ClientRoutes.CONTRACT_PRODUCT_BILLING,
      AdminRoutes.CONTRACT_PRODUCT_INVOICES,
      UpmindClientRoutes.CONTRACT_PRODUCT_BILLING
    ] as string[]).includes(this.$route.name as string);
  }
}
